import { IApiBaseResponse } from '~/utils/interface/common';
import axiosClient from './axiosClient';
import { IPayloadEditFile, IPayloadGenerateSignDocument, IResponseGetFile } from '~/utils/interface/file';

const fileApi = {
  getFile(id: string | undefined) {
    return axiosClient.get<IApiBaseResponse<IResponseGetFile>>(`api/admin/files/${id}`);
  },
  updateFile(id: string | undefined, data: IPayloadEditFile) {
    return axiosClient.put<IApiBaseResponse<null>>(`api/admin/files/${id}`, data);
  },
  generateSignDocument(data: IPayloadGenerateSignDocument) {
    return axiosClient.post<IApiBaseResponse<IResponseGetFile>>(`api/admin/files/generate-sign-document`, data);
  },
  downloadFileUrl(id: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetFile>>(`api/admin/files/download/${id}`);
  },
};

export default fileApi;
